// extracted by mini-css-extract-plugin
export default {"congratulationContainer":"Congratulations_congratulationContainer__8U+jX","success":"Congratulations_success__deK6Y"};